define('modules/signup/forget/view',['require','exports','module','jquery','backbone','views/BaseView','i18n','ThemesHelper','env','../../../helpers/UIHelper','ldsh!./template'],function(require, exports, module) {
    "use strict";

    var $ = require('jquery'),
        Backbone = require('backbone'),
        BaseView = require('views/BaseView'),
        i18n = require('i18n'),
        ThemesHelper = require('ThemesHelper'),
        Config = require('env'),
        UIHelper = require('../../../helpers/UIHelper');

    var ForgetView = BaseView.extend({
        template: require('ldsh!./template'),

        serialize: function () {
            return {
                globalAssetsURL: ThemesHelper.getCurrentThemeGlobalURL(),
                logoutUrl: Config.backendUrl + '/auth/logout'
            };
        },

        afterRender: function() {
            BaseView.prototype.afterRender.call(this);
            var self = this;

            UIHelper.expandBackground().listeningResize();

            $('#forgetForm').bootstrapValidator({
                onSuccess: function(e) {
                    e.preventDefault();
                    self.submitForm();
                }
            });
        },

        setEmailOnTemplate: function(email) {
            $('#forgetInfoOk').find('#emailInfo').html(email);
        },

        submitForm: function() {
            var self = this,
                email = $('#email').val();
            this.showSpinner();
            this.model.set({
                email: email
            });
            this.setEmailOnTemplate(email);
            this.model.save(null, {
                success: function() { self.showInfoOK(); },
                error: function() { self.showInfoOK(); }
            });
        },

        showSpinner: function() {
            $('#resetSubmitButton').attr('disabled', 'disabled');
            $('#resetSubmitButton i').show();
            $('#resetSubmitButton span').hide();
        },

        hideSpinner: function() {
            $('#resetSubmitButton').removeAttr('disabled');
            $('#resetSubmitButton i').hide();
            $('#resetSubmitButton span').show();
        },

        showInfoOK: function() {
            this.hideSpinner();

            $('#forgetDivForm').hide();
            $('#forgetInfoOk').show();
        }
    });


    module.exports = ForgetView;
});

